import { Link } from "react-router-dom";
import type { ReactNode } from "react";

export type Crumb = { label: string; href?: string };

type PageHeroProps = {
  kicker: string;
  title: string;
  desc: string;
  crumbs: Crumb[];
  aside?: ReactNode;
};

export default function PageHero({ kicker, title, desc, crumbs, aside }: PageHeroProps) {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1360px] px-4 py-8 md:px-6 md:py-12">
        <nav aria-label="面包屑导航" className="mb-5">
          <ol className="flex flex-wrap items-center gap-2 font-label text-xs text-foreground-500">
            {crumbs.map((crumb, index) => (
              <li key={crumb.label} className="flex items-center gap-2">
                {crumb.href ? (
                  <Link
                    to={crumb.href}
                    className="whitespace-nowrap transition-colors hover:text-primary-600"
                  >
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="whitespace-nowrap text-foreground-800">{crumb.label}</span>
                )}
                {index < crumbs.length - 1 ? (
                  <i className="ri-arrow-right-s-line text-foreground-400" />
                ) : null}
              </li>
            ))}
          </ol>
        </nav>

        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-3xl">
            <p className="mb-3 flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.22em] text-primary-600">
              <span className="block h-px w-7 bg-primary-500" aria-hidden="true" />
              {kicker}
            </p>
            <h1 className="mb-3 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
              {title}
            </h1>
            <p className="text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
          </div>
          {aside ? <div className="shrink-0">{aside}</div> : null}
        </div>
      </div>
    </section>
  );
}